import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { SidebarMenuButton, SidebarMenuItem, useSidebar } from "@altimateai/lego";
import { cn } from "@/lib/utils";
import { BetaTag } from "@/components/tags";

interface SidebarLinkProps {
  to: string;
  label: string;
  icon?: ReactNode;
  isBeta?: boolean;
  query?: string;
}

export const SidebarLink = ({ to, label, icon, isBeta, query }: SidebarLinkProps) => {
  const { pathname } = useLocation();
  const isActive = pathname.startsWith(to);
  const { state } = useSidebar();

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={isActive}
        tooltip={label}
        className={cn(
          "[&>svg]:al-size-5 al-text-muted-foreground data-[active=true]:!al-text-brand",
          state === "expanded" ? "al-p-3" : ""
        )}
      >
        <Link to={{ pathname: to, search: query }} state={{ breadcrumbReset: true }}>
          {icon}
          <span className="group-data-[state=collapsed]:al-hidden">{label}</span>
          {isBeta && <BetaTag className="group-data-[state=collapsed]:al-hidden" />}
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
